// extracted by mini-css-extract-plugin
export default {"building":"Dy1p7nsQMbMgxUsGhst_","elevatorBox":"uoSZYV3MLhSw0HuzxMGz"};